exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InvitationEventBox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n}\n.InvitationEventBox > div {\n  width: 2.96rem;\n  background: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -1.48rem;\n  margin-top: -1.67rem;\n  border-radius: 16px;\n  padding: 0.2rem;\n}\n.InvitationEventBox > div h3 {\n  text-align: center;\n  margin: 0;\n}\n.InvitationEventBox > div .am-icon-md {\n  display: block;\n  width: 0.34rem;\n  height: 0.34rem;\n  text-align: center;\n  line-height: 0.34rem;\n  border-radius: 50%;\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  bottom: -0.6rem;\n  margin-left: -0.17rem;\n  padding: 0.05rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/invitation/modules/InvitationEvent/index.less
// module id = 946
// module chunks = 0